import React from "react"
import { useDispatch } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Box } from "@material-ui/core"
import ReusableFormControl from "components/ReusableFormControl"
import MaskedMobileInput from "components/MaskedMobileInput"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { sendPin } from "actions/authentication"

const phoneSchema = Yup.object().shape({
  phone: Yup.string()
    .required("Required")
    .length(14, "Please enter a mobile phone number.")
})

const PhoneNumber = ({ classes, formRef, setWorking, handleStep }) => {
  const dispatch = useDispatch()

  const handleSubmit = values => {
    setWorking(true)
    dispatch(sendPin(values.phone))
      .then(res => {
        setWorking(false)
        handleStep()
      })
      .catch(error => {
        setWorking(false)
        handleStep()
      })
    // setWorking(false)
    // handleStep()
  }
  return (
    <Box className={classes.codeContainer}>
      <Formik
        innerRef={formRef}
        initialValues={{
          phone: ""
        }}
        validationSchema={phoneSchema}
        onSubmit={values => {
          handleSubmit(values)
        }}
      >
        {formikProps => (
          <Box className={classes.codeInputContainer}>
            <Form>
              <ReusableFormControl
                name="phone"
                label="Phone Number"
                formikProps={formikProps}
                inputProps={{
                  inputComponent: MaskedMobileInput,
                  classes: {
                    input: classes.white
                  },
                  className: classes.mobileInput
                }}
                inputLabelClass={classes.white}
              />
            </Form>
          </Box>
        )}
      </Formik>
    </Box>
  )
}

export default withStyles(styles)(PhoneNumber)



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/steps/PhoneNumber/index.js